<template>
    <div id="repNav">
      <div class="logo"><a href="#"><img src="https://corenroll-logo.s3.us-east-2.amazonaws.com/light-nuera.png" alt="enroll-prime" width="160">
      </a></div>
    </div>
</template>

<script>
export default {
name: "SignatureHeader"
}
</script>

<style scoped>
#repNav {
  padding: 30px 0 30px 0;
  position: relative;
  text-align: center;
}
</style>